// extracted by mini-css-extract-plugin
export default {"title":"Help_title__2ipZJ","cont":"Help_cont__6tpcU","conts":"Help_conts__ynJmH","box":"Help_box__N+9nn","how":"Help_how__ik2Gl"};